import { useEffect } from "react";
import loadingSpinner from "../../assests/page/loading-spinner.svg";
import { motion } from "framer-motion";

import { useGetCustodianDetails } from "../../hooks/managers";
import { getUserCustodyBanks } from "../../services/contracts/clientContract";
import { ethers } from "ethers";
import { errorToast } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import SuccessPopup from "../../components/popups/success";
import PaymentMethods from "../../components/popups/paymentMethods";
import useNetworkStore from "../../store/networkStore";
import useUserStore from "../../store/userSlice";
import { chainDetails } from "../../utils/config";
import {
  moneyHubClientUserAccessToken,
  moneyHubConnectLink,
  moneyHubCreateUser,
  moneyHubFetchAllConnections,
  moneyHubPaymentLink,
  moneyHubUserAccounts,
} from "../../utils/helpers/moneyhub";
import {
  blinkActiveBanks,
  blinkConnectLink,
  blinkCreatePayment,
  blinkPaymentStatus,
  blinkUserAccounts,
} from "../../utils/helpers/blink";
import {
  createStripeAccount,
  createStripeOnBoardLink,
  createVerifiedCashIssueRequest,
} from "../../utils/helpers/stripe";
import { useTranslation } from "react-i18next";

const MobileLoadingPage = (props) => {
  const { t } = useTranslation();
  const { chainId, provider, signer } = useNetworkStore();

  const { userAddress, userCountry, userId } = useUserStore();

  const {
    allCountries,
    selectedCountry,
    selectedCurrency,
    setPageAction,
    pageAction,
    pageStep,
    setPageStep,
    pageData,
    setPageData,
    selectedBank,
    isReloadStep,
  } = props.generalDataProps;

  const navigate = useNavigate();

  const {
    getCustodianDetailsData,
    getCustodianDetailsLoading,
    getCustodianDetailsError,
  } = useGetCustodianDetails(
    allCountries,
    pageAction === "card-payment"
      ? selectedCurrency?.tokenName
      : pageAction === "moneyhub-payment"
        ? "MONEYHUB"
        : pageAction === "blink-payment"
          ? "BLINK"
          : "",
    chainDetails[chainId].spotCustodian,
  );

  useEffect(() => {
    const getMoneyHubConnectLink = async () => {
      if (signer) {
        await getUserCustodyBanks(chainId, userAddress, signer).then(
          async (res) => {
            if (res) {
              if (
                res.length > 0 &&
                res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "MONEYHUB"?.toLowerCase(),
                )
              ) {
                const userIdRaw = (res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "MONEYHUB"?.toLowerCase(),
                )).account;
                const userId = ethers.utils.parseBytes32String(userIdRaw);

                if (isReloadStep) {
                  await moneyHubConnectLink(userId).then((_res) => {
                    if (_res) {
                      window.location.href = _res;
                    } else {
                      errorToast(
                        "Oops Something went wrong",
                        "Unexpected error try again later.",
                      );
                      setPageStep("2");
                      setPageAction("link-bank");
                      navigate("/link-bank");
                    }
                  });
                } else {
                  await moneyHubClientUserAccessToken(userId).then(
                    async (authTk) => {
                      if (authTk) {
                        await moneyHubUserAccounts(authTk).then(
                          async (_res) => {
                            if (_res && _res.length > 0) {
                              const allMoneyHubConnections =
                                await moneyHubFetchAllConnections();
                              const resFmt = _res.map((acct) => {
                                return {
                                  ...acct,
                                  iconUrl: allMoneyHubConnections.find(
                                    (cnt) =>
                                      cnt?.id?.toLowerCase() ===
                                      acct?.providerId,
                                  )?.iconUrl,
                                  customProvider: "moneyhub",
                                };
                              });
                              setPageData(resFmt);
                              setPageStep("3");
                              setPageAction("link-bank");
                              navigate("/link-bank");
                            } else if (_res && _res.length === 0) {
                              await moneyHubConnectLink(userId).then((_res) => {
                                if (_res) {
                                  window.location.href = _res;
                                } else {
                                  errorToast(
                                    "Oops Something went wrong",
                                    "Unexpected error try again later.",
                                  );
                                  setPageStep("2");
                                  setPageAction("link-bank");
                                  navigate("/link-bank");
                                }
                              });
                            } else {
                              errorToast(
                                "Oops Something went wrong",
                                "Unexpected error try again later.",
                              );
                              setPageStep("2");
                              setPageAction("link-bank");
                              navigate("/link-bank");
                            }
                          },
                        );
                      } else {
                        errorToast(
                          "Oops Something went wrong",
                          "Unexpected error try again later.",
                        );
                        setPageStep("2");
                        setPageAction("link-bank");
                        navigate("/link-bank");
                      }
                    },
                  );
                }
              } else {
                await moneyHubCreateUser(userAddress).then(async (res) => {
                  if (res) {
                    const userId = res.userId;
                    await moneyHubConnectLink(userId).then((_res) => {
                      if (_res) {
                        window.location.href = _res;
                      } else {
                        errorToast(
                          "Oops Something went wrong",
                          "Unexpected error try again later.",
                        );
                        setPageStep("2");
                        setPageAction("link-bank");
                        navigate("/link-bank");
                      }
                    });
                  } else {
                    errorToast(
                      "Oops Something went wrong",
                      "Error while creating moneyhub account. Try again  later",
                    );
                    setPageStep("2");
                    setPageAction("link-bank");
                    navigate("/link-bank");
                  }
                });
              }
            } else {
              errorToast(
                "Oops Something went wrong",
                "Unexpected error try again later.",
              );
              setPageStep("2");
              setPageAction("link-bank");
              navigate("/link-bank");
            }
          },
        );
      }
    };

    const getMoneyhubAccounts = async () => {
      await moneyHubClientUserAccessToken(pageData[0]?.id).then(
        async (authTk) => {
          if (authTk) {
            await moneyHubUserAccounts(authTk).then(async (_res) => {
              if (_res && _res.length > 0) {
                const allMoneyHubConnections =
                  await moneyHubFetchAllConnections();
                const resFmt = _res.map((acct) => {
                  return {
                    ...acct,
                    iconUrl: allMoneyHubConnections.find(
                      (cnt) => cnt?.id?.toLowerCase() === acct?.providerId,
                    )?.iconUrl,
                    custodyCurrencyType: "moneyhub",
                    userId: pageData[0]?.id,
                  };
                });
                setPageAction("add-funds");
                setPageData(resFmt);
                navigate("/select-bank");
              } else {
                setPageAction("add-funds");
                setPageData([]);
                navigate("/select-bank");
              }
            });
          } else {
            setPageAction("add-funds");
            setPageData([]);
            navigate("/select-bank");
          }
        },
      );
    };

    const getBlinkConnectLink = async () => {
      if (signer) {
        await getUserCustodyBanks(chainId, userAddress, signer).then(
          async (res) => {
            if (res) {
              if (
                res.length > 0 &&
                res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "BLINK"?.toLowerCase(),
                )
              ) {
                const userIdRaw = (res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "BLINK"?.toLowerCase(),
                )).account;
                const userId = ethers.utils.parseBytes32String(userIdRaw);
                if (isReloadStep) {
                  await blinkConnectLink(userId, selectedBank?.id).then(
                    (lnk) => {
                      if (lnk) {
                        window.location.href = lnk;
                      } else {
                        errorToast(
                          "Oops Something went wrong",
                          "Unexpected error try again later.",
                        );
                        setPageStep("2");
                        setPageAction("link-bank");
                        navigate("/link-bank");
                      }
                    },
                  );
                } else {
                  await blinkUserAccounts(userId, selectedBank?.id, true).then(
                    async (_res) => {
                      if (_res && _res?.accounts?.length > 0) {
                        const allBanks = await blinkActiveBanks();
                        const resFmt = _res?.accounts?.map((acct) => {
                          return {
                            ...acct,
                            iconUrl: allBanks.find(
                              (cnt) =>
                                cnt?.providerId?.toLowerCase() ===
                                _res?.providerId?.toLowerCase(),
                            )?.logo,
                            customProvider: "blink",
                          };
                        });
                        setPageData(resFmt);
                        setPageStep("3");
                        setPageAction("link-bank");
                        navigate("/link-bank");
                      } else {
                        await blinkConnectLink(userId, selectedBank?.id).then(
                          (lnk) => {
                            if (lnk) {
                              window.location.href = lnk;
                            } else {
                              errorToast(
                                "Oops Something went wrong",
                                "Unexpected error try again later.",
                              );
                              setPageStep("2");
                              setPageAction("link-bank");
                              navigate("/link-bank");
                            }
                          },
                        );
                      }
                    },
                  );
                }
              } else {
                const newId =
                  userId +
                  userAddress.slice(
                    userAddress?.length - 8,
                    userAddress?.length,
                  );
                await blinkConnectLink(
                  newId.slice(0, 31),
                  selectedBank?.id,
                ).then((lnk) => {
                  if (lnk) {
                    window.location.href = lnk;
                  } else {
                    errorToast(
                      "Oops Something went wrong",
                      "Unexpected error try again later.",
                    );
                    setPageStep("2");
                    setPageAction("link-bank");
                    navigate("/link-bank");
                  }
                });
              }
            } else {
              errorToast(
                "Oops Something went wrong",
                "Unexpected error try again later.",
              );
              setPageStep("2");
              setPageAction("link-bank");
              navigate("/link-bank");
            }
          },
        );
      }
    };

    const getBlinkAccounts = async () => {
      await blinkUserAccounts(pageData[0]?.id, selectedBank?.id, true).then(
        async (_res) => {
          if (_res && _res?.accounts?.length > 0) {
            const allBanks = await blinkActiveBanks();
            const resFmt = _res?.accounts?.map((acct) => {
              return {
                ...acct,
                iconUrl: allBanks.find(
                  (cnt) =>
                    cnt?.providerId?.toLowerCase() ===
                    _res?.providerId?.toLowerCase(),
                )?.logo,
                custodyCurrencyType: "blink",
                providerId: _res?.providerId,
                userId: pageData[0]?.id,
              };
            });

            setPageData(resFmt);
            setPageAction("add-funds");
            navigate("/select-bank");
          } else {
            setPageData([]);
            setPageAction("add-funds");
            navigate("/select-bank");
          }
        },
      );
    };

    const getOrCreateStripeAccount = async () => {
      if (signer) {
        await getUserCustodyBanks(chainId, userAddress, signer).then(
          async (res) => {
            if (res) {
              if (
                res.length > 0 &&
                res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase()
                      ?.split("-")[0] ===
                      selectedCountry?.code?.toLowerCase() &&
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase()
                      ?.split("-")[1]?.length > 0,
                )
              ) {
                setTimeout(() => {
                  setPageAction("Authentication");
                  props.setPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Congratulations!"
                      customTextFooter={`You have successfully linked your Stripe account in ${selectedCountry?.code}`}
                      setFavouriteClicked={props.setFavouriteClicked}
                      showButton={true}
                      mobileScreen={props.mobileScreen}
                    />,
                  );
                  props.setPopupContentPosition("center");
                  props.setShowPopup(true);
                }, 1000);
              } else {
                await createStripeAccount(
                  userAddress,
                  chainId,
                  selectedCountry?.code,
                ).then(async (res) => {
                  if (res) {
                    await createStripeOnBoardLink(
                      res,
                      selectedCountry?.code,
                      chainId,
                    ).then((_res) => {
                      if (_res) {
                        window.location.href = _res;
                      } else {
                        errorToast(
                          "Oops Something went wrong",
                          "Unexpected error try again later.",
                        );
                        setPageStep("2");
                        setPageAction("link-card");
                        navigate("/link-card");
                      }
                    });
                  } else {
                    errorToast(
                      "Unable to create Stripe account",
                      "Stripe may not be supported in your country confirm your contry is supported and try again later.",
                    );
                    setPageStep("2");
                    setPageAction("link-card");
                    navigate("/link-card");
                  }
                });
              }
            } else {
              errorToast(
                "Oops Something went wrong",
                "Unexpected error try again later.",
              );
              setPageStep("2");
              setPageAction("link-card");
              navigate("/link-card");
            }
          },
        );
      }
    };

    const handleCardPayment = async () => {
      if (
        getCustodianDetailsData?.custodians?.length > 0 &&
        chainId &&
        userAddress
      ) {
        await createVerifiedCashIssueRequest(
          chainId,
          userAddress,
          selectedCurrency?.amount,
          "CH", //default supported stripe country code to trigger stripe payment
          pageData && pageData[0]
            ? pageData[0]?.accountId
            : getCustodianDetailsData?.custodians[0]?.accountId,
          selectedCurrency?.tokenName?.replace("VC", "")?.toUpperCase(),
          selectedCurrency?.tokenAddress,
        ).then((_res) => {
          if (_res) {
            props.setPopupContentPosition("center");
            props.setPopupContent(
              <PaymentMethods
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                setFavouriteClicked={props.setFavouriteClicked}
                selectedCurrency={props.selectedCurrency || selectedCurrency}
                generalDataProps={props.generalDataProps}
                paymentSecret={_res.client_secret}
                showPaymentPortal={true}
                paymentType={"card"}
                custodians={getCustodianDetailsData?.custodians}
                custodianDetails={
                  pageData && pageData[0]
                    ? pageData[0]
                    : getCustodianDetailsData?.custodians[0]
                }
                mobileScreen={props.mobileScreen}
              />,
            );
            props.setShowPopup(true);
          } else {
            errorToast(
              "Oops Something went wrong",
              "Verify payment amount and try again later.",
            );
            navigate("/add-funds-method");
          }
        });
      } else if (getCustodianDetailsData?.custodians?.length === 0) {
        errorToast(
          "Oops Something went wrong",
          "No Verified custodian for selected currency.",
        );
        navigate("/add-funds-method");
      }
    };

    const handleMoneyHubPayment = async () => {
      if (
        getCustodianDetailsData?.custodians?.length > 0 &&
        chainId > 0 &&
        userAddress &&
        pageData?.length > 0
      ) {
        await moneyHubClientUserAccessToken(
          getCustodianDetailsData?.custodians[0]?.accountId,
        ).then(async (authTk) => {
          if (authTk) {
            await moneyHubUserAccounts(authTk).then(async (_res) => {
              if (_res && _res?.length > 0) {
                const {
                  payer_id,
                  payer_bank_id,
                  payer_bank_account_id,
                  payer_bank_type,
                  payer_bank_connection_id,
                  payer_name,
                  payer_email,
                  amount_in_pence,
                  context,
                } = pageData[0];

                const accountToUse = _res?.find(
                  (bnk) =>
                    bnk?.providerId === payer_bank_id &&
                    bnk?.type === payer_bank_type,
                )
                  ? _res?.find(
                      (bnk) =>
                        bnk?.providerId === payer_bank_id &&
                        bnk?.type === payer_bank_type,
                    )
                  : _res?.find((bnk) => bnk?.type === payer_bank_type)
                    ? _res?.find((bnk) => bnk?.type === payer_bank_type)
                    : _res[0];

                await moneyHubPaymentLink(
                  payer_id,
                  payer_bank_id,
                  payer_bank_account_id,
                  payer_bank_connection_id,
                  payer_name,
                  payer_email,
                  amount_in_pence,
                  getCustodianDetailsData?.custodians[0]?.accountId,
                  accountToUse?.id,
                  context,
                ).then((lnk) => {
                  if (lnk?.id && lnk?.redirectParams) {
                    window.location.href = lnk?.redirectParams?.authUrl;
                  } else if (!lnk) {
                    errorToast(
                      "Oops Something went wrong",
                      "Error while creating payment request",
                    );
                    navigate("/add-funds-method");
                  }
                });
              }
            });
          }
        });
      } else if (getCustodianDetailsData?.custodians?.length === 0) {
        errorToast(
          "Oops Something went wrong",
          "No Verified custodian for selected currency.",
        );
        navigate("/add-funds-method");
      }
    };

    const handleBlinkPayment = async () => {
      if (
        getCustodianDetailsData?.custodians?.length > 0 &&
        chainId &&
        userAddress &&
        pageData[0]
      ) {
        await blinkUserAccounts(
          getCustodianDetailsData?.custodians[0]?.accountId,
          selectedBank?.providerId,
          true,
        ).then(async (_res) => {
          if (_res && _res?.accounts?.length > 0) {
            const accountToUse = _res?.accounts?.find(
              (acct) =>
                acct?.account?.type === payer_account?.type &&
                acct?.account?.identification !== payer_account?.identification,
            );

            const {
              provider_id,
              payer_id,
              payer_account,
              amount,
              amount_currency_symbol,
            } = pageData[0];

            await blinkCreatePayment(
              provider_id,
              payer_id,
              payer_account,
              amount,
              amount_currency_symbol,
              accountToUse?.account,
              accountToUse?.accountOwner,
              getCustodianDetailsData?.custodians[0]?.countryCode,
            ).then(async (res) => {
              const paymentId = res?.location?.replace("/payments/", "");
              const providerId = res?.provider;
              await blinkPaymentStatus(payer_id, providerId, paymentId).then(
                (_res) => {
                  if (_res?.statusCode?.startsWith("ACCP")) {
                    props.setPopupContentPosition("center");
                    props.setPopupContent(
                      <SuccessPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        isCustom={true}
                        customTextHeader="Payment Successfull!"
                        customTextFooter={`Our Custodian will review your payment and top up equivalent ${selectedCurrency?.tokenName?.toUpperCase()}`}
                        setFavouriteClicked={props.setFavouriteClicked}
                        showButton={true}
                        generalDataProps={props.generalDataProps}
                        mobileScreen={props.mobileScreen}
                      />,
                    );
                    props.setShowPopup(true);
                  }
                },
              );
            });
          } else {
            const {
              provider_id,
              payer_id,
              payer_account,
              amount,
              amount_currency_symbol,
            } = pageData[0];
            //use an hardcoded account till we have multiple blink users accounts
            await blinkCreatePayment(
              provider_id,
              payer_id,
              payer_account,
              amount,
              amount_currency_symbol,
              { type: "IBAN", identification: "CH5604835012345678009" },
              "Validor Ibanus",
              "CH",
            ).then(async (res) => {
              const paymentId = res?.location?.replace("/payments/", "");
              const providerId = res?.provider;
              await blinkPaymentStatus(payer_id, providerId, paymentId).then(
                (_res) => {
                  if (_res?.statusCode?.startsWith("ACCP")) {
                    props.setPopupContentPosition("center");
                    props.setPopupContent(
                      <SuccessPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        isCustom={true}
                        customTextHeader="Payment Successfull!"
                        customTextFooter={`Our Custodian will review your payment and top up equivalent ${selectedCurrency?.tokenName?.toUpperCase()}`}
                        setFavouriteClicked={props.setFavouriteClicked}
                        showButton={true}
                        generalDataProps={props.generalDataProps}
                        mobileScreen={props.mobileScreen}
                      />,
                    );
                    props.setShowPopup(true);
                  }
                },
              );
            });
          }
        });
      } else if (getCustodianDetailsData?.custodians?.length === 0) {
        errorToast(
          "Oops Something went wrong",
          "No Verified custodian for selected currency.",
        );
        navigate("/add-funds-method");
      }
    };

    if (
      pageAction === "moneyhub-connect" &&
      userAddress &&
      chainId > 0 &&
      signer
    ) {
      getMoneyHubConnectLink();
    }

    if (pageAction === "moneyhub-acounts" && pageData?.length > 0) {
      getMoneyhubAccounts();
    }

    if (
      pageAction === "blink-connect" &&
      userAddress &&
      userId &&
      chainId > 0 &&
      signer
    ) {
      getBlinkConnectLink();
    }

    if (
      pageAction === "blink-acounts" &&
      pageData?.length > 0 &&
      selectedBank?.id
    ) {
      getBlinkAccounts();
    }

    if (
      pageAction === "stripe-connect" &&
      selectedCountry?.code &&
      userAddress?.length > 0 &&
      chainId > 0 &&
      signer
    ) {
      getOrCreateStripeAccount();
    }

    if (pageAction === "card-payment" && userAddress && chainId > 0 && signer) {
      handleCardPayment();
    }

    if (
      pageAction === "moneyhub-payment" &&
      userAddress &&
      chainId > 0 &&
      signer
    ) {
      handleMoneyHubPayment();
    }

    if (
      pageAction === "blink-payment" &&
      userAddress &&
      chainId > 0 &&
      pageData?.length > 0 &&
      signer
    ) {
      handleBlinkPayment();
    }
  }, [
    chainId,
    getCustodianDetailsData?.custodians,
    isReloadStep,
    navigate,
    pageAction,
    pageData,
    props,
    provider,
    selectedBank?.id,
    selectedBank?.providerId,
    selectedCountry,
    selectedCurrency,
    setPageAction,
    setPageData,
    setPageStep,
    signer,
    userAddress,
    userId,
  ]);

  return (
    <>
      {pageAction === "" && (
        <div
          style={{
            alignContent: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
          className="success-popup-content-container"
        >
          <div className="success-popup-content">
            <motion.img
              height="100px"
              width="100px"
              src={loadingSpinner}
              alt={`${t("common.loading")}...`}
              animate={{
                rotate: 360,
                scale: [1, 1.5, 1],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "linear",
              }}
            />
            <div className="success-popup-content-text">
              <p
                id="loading-popup-title"
                className="success-popup-content-text-header"
              >
                Searching...
              </p>
              <p
                id="loading-popup-label"
                className="success-popup-content-text-footer"
              >
                Looking for broker accounts linked with your phone number.
              </p>
            </div>
          </div>
        </div>
      )}
      {pageAction !== "" && (
        <div
          style={{
            alignContent: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
          className="success-popup-content-container"
        >
          <div className="success-popup-content">
            <motion.img
              height="100px"
              width="100px"
              src={loadingSpinner}
              alt={`${t("common.loading")}...`}
              animate={{
                rotate: 360,
                scale: [1, 1.5, 1],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "linear",
              }}
            />
            <div className="success-popup-content-text">
              {pageAction === "moneyhub-connect" && (
                <>
                  <p className="success-popup-content-text-header">
                    Searching...
                  </p>
                  <p className="success-popup-content-text-footer">
                    Looking for bank account linked with your wallet.
                  </p>
                </>
              )}
              {pageAction === "blink-connect" && (
                <>
                  <p className="success-popup-content-text-header">
                    Searching...
                  </p>
                  <p className="success-popup-content-text-footer">
                    Looking for bank account linked with your wallet.
                  </p>
                </>
              )}
              {pageAction === "stripe-connect" && (
                <>
                  <p className="success-popup-content-text-header">
                    Searching...
                  </p>
                  <p className="success-popup-content-text-footer">
                    Looking for card linked with your wallet in{" "}
                    {selectedCountry.code}
                  </p>
                </>
              )}
              {pageAction === "card-payment" && (
                <>
                  <p className="success-popup-content-text-header">
                    Initializing...
                  </p>
                  <p className="success-popup-content-text-footer">
                    {`Creating card payment gateway for ${selectedCurrency?.tokenName.replace(
                      "VC",
                      "",
                    )}`}
                  </p>
                </>
              )}
              {pageAction === "moneyhub-acounts" && (
                <>
                  <p className="success-popup-content-text-header">
                    Searching...
                  </p>
                  <p className="success-popup-content-text-footer">
                    fetching all linked bank accounts
                  </p>
                </>
              )}

              {pageAction === "blink-acounts" && (
                <>
                  <p className="success-popup-content-text-header">
                    Searching...
                  </p>
                  <p className="success-popup-content-text-footer">
                    fetching all linked bank accounts
                  </p>
                </>
              )}

              {pageAction === "moneyhub-payment" && (
                <>
                  <p className="success-popup-content-text-header">
                    Initializing...
                  </p>
                  <p className="success-popup-content-text-footer">
                    {`Creating bank payment gateway for ${selectedCurrency?.tokenName.replace(
                      "VC",
                      "",
                    )}`}
                  </p>
                </>
              )}

              {pageAction === "blink-payment" && (
                <>
                  <p className="success-popup-content-text-header">
                    Initializing...
                  </p>
                  <p className="success-popup-content-text-footer">
                    {`Creating bank payment gateway for ${selectedCurrency?.tokenName.replace(
                      "VC",
                      "",
                    )}`}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileLoadingPage;
